import React from 'react';

import UIStrings from '@/Utils/UIStrings';

const AdjustedByRecruiterChip = () => {
    return (
        <div
            data-cy="AdjustedByRecruiterChip"
            className="bg-primary/10 text-primary flex max-w-64 flex-row items-center rounded-md px-1 py-0.5"
        >
            <span className="truncate px-1.5 text-xs font-medium">{UIStrings.AdjustedByRecruiter}</span>
        </div>
    );
};

export default AdjustedByRecruiterChip;
